import logo from "assets/svg/fullLogo.svg";
import bell from "assets/svg/bell.svg";
import { MenuIcon } from "assets/icons";
import { useUiStore } from "store/zustand-store/uiStore";

interface AdminMobileNavbarProps {
  className?: string;
}

const AdminMobileNavbar = ({ className = "" }: AdminMobileNavbarProps) => {
  const openSidebar = useUiStore((state) => state.openSidebar);

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-20 border-b border-[#E4E7EC] bg-[#F6F3EF] px-4 py-4 sm:px-5 lg:hidden ${className}`}
    >
      <nav className="flex h-10 items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <button
            type="button"
            aria-label="Open navigation menu"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-[#EBEBEB] bg-[#FAFAFA]"
            onClick={(event) => {
              event.stopPropagation();
              openSidebar();
            }}
          >
            <MenuIcon width={18} height={18} />
          </button>
          <img src={logo} alt="stagepanda" className="w-[120px] shrink-0" />
        </div>

        <img
          className="h-9 w-9 shrink-0 rounded-lg border border-[#EBEBEB] bg-[#FAFAFA] p-[7px]"
          src={bell}
          alt="Notifications"
        />
      </nav>
    </header>
  );
};

export default AdminMobileNavbar;
